import { AxiosResponse } from 'axios'
import { axiosInstance } from '~/src/config/config_axios'
import { IMeResponse } from './models/Me'

export class MeRepository {
  async getMeStatus(): Promise<AxiosResponse<IMeResponse['data']>> {
    return await axiosInstance.get('/me/status')
  }
}
